import { Button, Tooltip } from '@mui/material'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import useCreateRideDialog from '../../../../hooks/useCreateRideDialog'
import useUserIsReadOnly from '../../../../hooks/useUserIsReadOnly'

const RidesActions = () => {
  const openDialog = useCreateRideDialog()
  const isRideOnly = useUserIsReadOnly()
  return (
    <>
      <Tooltip title={isRideOnly ? 'Access Denied' : ''}>
        <span>
          <Button
            disabled={isRideOnly}
            size="small"
            className="add-ride-button"
            variant="contained"
            onClick={() => openDialog()}
            startIcon={<AddCircleIcon />}>
        Create Ride
          </Button>
        </span>
      </Tooltip>
    </>
  )
}

export default RidesActions

